export enum TargetKind {
  Additive = 0,
  Rate = 1,
  Level = 2,
}

export enum TargetDirection {
  HigherIsBetter = 0,
  LowerIsBetter = 1,
  Band = 2,
  Neutral = 3,
}

export const KIND_LABELS: Record<TargetKind, string> = {
  [TargetKind.Additive]: "Additive",
  [TargetKind.Rate]: "Rate",
  [TargetKind.Level]: "Level",
};

export const DIRECTION_LABELS: Record<TargetDirection, string> = {
  [TargetDirection.HigherIsBetter]: "Higher is better",
  [TargetDirection.LowerIsBetter]: "Lower is better",
  [TargetDirection.Band]: "Within a band",
  [TargetDirection.Neutral]: "Not judged",
};

export interface DataSourceFilterDTO {
  field: string;
  equals?: string;
  notEquals?: string;
  in?: string[];
  notIn?: string[];
  greaterThan?: number;
  greaterThanOrEqual?: number;
  lessThan?: number;
  lessThanOrEqual?: number;
}

export interface TargetFormulaSideDTO {
  expression: string;
  filters?: DataSourceFilterDTO[] | null;
}

export interface TargetFormulaDTO {
  endpoint: string;
  numerator: TargetFormulaSideDTO;
  denominator?: TargetFormulaSideDTO | null;
  scale?: number;
}
